import { type Variants } from 'motion/react'

export const containerVariants: Variants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.2,
            delayChildren: 0.5,
        },
    },
}

export const introModalBackdropVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            duration: 0.32,
            ease: 'easeOut',
        },
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.16,
            ease: 'easeIn',
        },
    },
}

export const introModalCardVariants: Variants = {
    hidden: { y: 250, opacity: 0, scale: 0.82 },
    visible: {
        y: 0,
        opacity: 1,
        scale: 1,
        transition: {
            delay: 0.24,
            duration: 0.68,
            ease: [0.22, 1, 0.36, 1],
        },
    },
    exit: {
        y: 250,
        opacity: 0,
        scale: 0.9,
        transition: {
            duration: 0.2,
            ease: 'easeIn',
        },
    },
}

export const tabContainerVariants: Variants = {
    hidden: {
        y: '-100%',
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            type: 'spring',
            stiffness: 320,
            damping: 18,
            mass: 0.9,
            staggerChildren: 0.08,
            delayChildren: 0.15,
        },
    },
}

export const tabButtonVariants: Variants = {
    hidden: {
        scale: 0,
        opacity: 0,
    },
    visible: {
        scale: 1,
        opacity: 1,
        transition: {
            type: 'spring',
            stiffness: 500,
            damping: 15,
        },
    },
}

export const gameControlsVariants: Variants = {
    hidden: {
        y: 150,
    },
    visible: {
        y: 0,
        transition: {
            type: 'spring',
            stiffness: 400,
            damping: 22,
            mass: 0.9,
        },
    },
}

const gameHudSpring = {
    type: 'spring' as const,
    stiffness: 400,
    damping: 22,
    mass: 0.9,
}

export const gameHudVariants: Variants = {
    hidden: (hiddenOffset: number = -150) => ({
        y: hiddenOffset,
        transition: gameHudSpring,
    }),
    visible: {
        y: 0,
        transition: gameHudSpring,
    },
}

export const parentsInfoBannerBlockVariants: Variants = {
    hidden: {
        y: '-100%',
        opacity: 0,
        transition: gameHudSpring,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: gameHudSpring,
    },
    exit: {
        y: '-100%',
        opacity: 0,
        transition: gameHudSpring,
    },
}